import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=c9fc351c&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
import style0 from "./accounts.vue?vue&type=style&index=0&id=c9fc351c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fc351c",
  null
  
)

export default component.exports